module.exports = __webpack_public_path__ + "img/hgzQRCode.3497f4f4.jpg";